/** @format */
import {RefObject, useLayoutEffect, useRef, useState} from 'react';

interface ReturnValue<T extends HTMLElement> {
  height: number;
  blockRef: RefObject<T>;
}

/**
 * Хук вычисляет высоту блока при известной ширине.
 * ratio меньше единицы даст высоту меньшую, чем ширина.
 * @param ratio
 */

const useAspectRatio = <T extends HTMLElement>(ratio: number): ReturnValue<T> => {
  const [height, setHeight] = useState<number>(0);

  const blockRef = useRef<T>(null);

  useLayoutEffect(() => {
    const node = blockRef.current;
    if (!node) return;

    const updateHeight = () => {
      const newHeight = Math.round(node.clientWidth * ratio);
      setHeight(newHeight);
    };

    updateHeight();

    const resizeObserver = new ResizeObserver(() => {
      updateHeight();
    });

    resizeObserver.observe(node);

    return () => {
      resizeObserver.disconnect();
    };
  }, [ratio]);

  return {
    height,
    blockRef,
  };
};

export {useAspectRatio};
